const KanyeWestSongs =  [
      "'03 Bonnie & Clyde",
      "4th Dimension",
      "24",
      "30 Hours",
      "All Day",
      "All Falls Down",
      "All Mine",
      "All of the Lights",
      "All We Got",
      "All Your Fault",
      "Amazing",
      "American Boy",
      "Bad News",
      "Ballin",
      "Believe What I Say",
      "Big Brother",
      "Birthday Song",
      "Black Skinhead",
      "Blame Game",
      "Blazin'",
      "Blessings",
      "Blood on the Leaves",
      "The Bounce",
      "Bound 2",
      "Brand New",
      "Brothers",
      "Can't Tell Me Nothing",
      "Castro",
      "Champion",
      "Champions",
      "Champions",
      "Christmas in Harlem",
      "City of Gods",
      "Classic",
      "Clique",
      "Closed on Sunday",
      "Cold",
      "Coldest Winter",
      "Come to Life",
      "Cops Shot the Kid",
      "The Corner",
      "Cudi Montage",
      "Dark Fantasy",
      "Devil in a New Dress",
      "Diamonds from Sierra Leone",
      "Donda Chant",
      "Down and Out",
      "Drive Slow",
      "Drunk and Hot Girls",
      "Drunk in Love",
      "Eazy",
      "Ego",
      "Ego Death",
      "Erase Me",
      "E.T.",
      "Every Hour",
      "Everyone Nose",
      "Everything I Am",
      "Everything We Need",
      "Excuse Me Miss",
      "Extravaganza",
      "Facts",
      "Fade",
      "Fall Out of Heaven",
      "Famous",
      "Father Stretch My Hands",
      "Feedback",
      "Feel Me",
      "Feel the Love",
      "Figure It Out",
      "Finer Things",
      "Fire",
      "Flashing Lights",
      "FML",
      "Follow God",
      "The Food",
      "Forever",
      "FourFiveSeconds",
      "Frank's Track",
      "Freeee",
      "Freestyle 4",
      "Take Me to the Light",
      "Get By",
      "Ghost Town",
      "The Glory",
      "Glow",
      "Go Hard",
      "Go!",
      "Go2DaMoon",
      "God Breathed",
      "God Level",
      "Gold Digger",
      "Gone",
      "Good Life",
      "Good Morning",
      "Gorgeous",
      "Gossip Files",
      "Gotta Have It",
      "Grammy Family",
      "Guilt Trip",
      "H.A.M.",
      "Hands On",
      "Heard 'Em Say",
      "Heartless",
      "Hell of a Life",
      "Hey Mama",
      "Highlights",
      "Hold My Liquor",
      "Homecoming",
      "Hot Shit",
      "Hurricane",
      "Hurry",
      "I Am a God",
      "I Changed My Mind",
      "I Feel Like That",
      "I Love It",
      "I Love Kanye",
      "I Still Love H.E.R.",
      "I Thought About Killing You",
      "I Wish You Would",
      "I Won",
      "I Wonder",
      "I'm in It",
      "Illest Motherfucker Alive",
      "Impossible",
      "Jail",
      "Jesus Is Lord",
      "Jesus Walks",
      "Jonah",
      "The Joy",
      "Jukebox Joints",
      "Junya",
      "Junya pt 2",
      "Kanga",
      "Keep It Burnin",
      "Keep My Spirit Alive",
      "Kids See Ghosts",
      "Kinda Like a Big Deal",
      "Knock You Down",
      "LA Monster",
      "Life of the Party",
      "Lift Off",
      "Lift Yourself",
      "Live Fast, Die Young",
      "Looking for Trouble",
      "Lord Lord Lord",
      "Lost in the World",
      "Love Lockdown",
      "Low Lights",
      "Made in America",
      "Make Her Say",
      "Mama",
      "Mama's Boyfriend",
      "Marvin & Chardonnay",
      "Maybach Music 2",
      "Mercy",
      "Midas Touch",
      "Mixed Personalities",
      "Monster",
      "Moon",
      "The Morning",
      "Mr. Miyagi",
      "Murder to Excellence",
      "My Baby",
      "Nah Nah Nah",
      "Never Let Me Down",
      "New Again",
      "New Body",
      "New God Flow",
      "New Slaves",
      "The New",
  
          "New God Flow",
          "New Slaves",
          "The New Workout Plan",
          "N****s in Paris",
          "No Child Left Behind",
          "No Church in the Wild",
          "No Mistakes",
          "No More Parties in LA",
          "Nobody",
          "Number One",
          "Number One",
          "Off the Grid",
          "On God",
          "On Sight",
          "One Man Can Change the World",
          "One Minute",
          "Only One",
          "Otis",
          "Paranoid",
          "Perfect Bitch",
          "Pop Style",
          "Power",
          "Praise God",
          "Pride N Joy",
          "Primetime",
          "Pro Nails",
          "Pure Souls",
          "Pussy Print",
          "Put On",
          "Real Friends",
          "Reborn",
          "Remote Control",
          "RoboCop",
          "Run This Town",
          "Runaway",
          "Saint Pablo",
          "Sanctified",
          "Say You Will",
          "Scapegoat",
          "School Spirit",
          "See Me Now",
          "See You in My Nightmares",
          "Selah",
          "Send It Up",
          "Side 2 Side",
          "Siiiiiiiiilver Surffffeeeeer Intermission",
          "Slow Jamz",
          "Smuckers",
          "So Appalled",
          "Spaceship",
          "Start It Up",
          "Stay Up! (Viagra)",
          "Street Lights",
          "Stronger",
          "Supernova",
          "Swagga Like Us",
          "Talk About Our Love",
          "Tell the Vision",
          "Teriyaking",
          "Thank You",
          "That Part",
          "That's My Bitch",
          "Therapy",
          "This Way",
          "Through the Wire",
          "Touch the Sky",
          "True Love",
          "Two Words",
          "U Mad",
          "Ultralight Beam",
          "Up from the Ashes",
          "Us Placers",
          "Use This Gospel",
          "Violent Crimes",
          "Walkin' on the Moon",
          "Wash Us in the Blood",
          "Watch",
          "Water",
          "Waves",
          "Welcome 2 Chicago",
          "Welcome Back",
          "Welcome to Heartbreak",
          "Welcome to the Jungle",
          "Welcome to the World",
          "Whatever U Want",
          "White Dress",
          "Who Gon Stop Me",
          "Why I Love You",
          "Wolves",
          "Wouldn't Get Far",
          "Wouldn't Leave",
          "XTCY",
          "Ye vs. the People",
          "Yikes"
        ]
      
export default KanyeWestSongs;
        